var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{
      'text-left bg-menu p-3 pt-1 pb-1 text-white': !_vm.$props.noStyle
    }},[(!_vm.$props.noStyle)?_c('label',{},[_c('i',{staticClass:"fa fa-cash-register mr-3"}),_vm._v("Caixa ")]):_vm._e(),_c('b-select',{attrs:{"options":_vm.caixas},model:{value:(_vm.cod_caixa),callback:function ($$v) {_vm.cod_caixa=$$v},expression:"cod_caixa"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }